import { render, staticRenderFns } from "./VDialogAction.vue?vue&type=template&id=5987efe6&"
import script from "./VDialogAction.vue?vue&type=script&lang=js&"
export * from "./VDialogAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports